import { useEffect, useState } from "react";
import { Eye } from "lucide-react";

const KEY = "kindred_a11y";

export function applyA11y(on) {
  document.documentElement.classList.toggle("a11y", on);
}

export default function A11yToggle({ compact = false }) {
  const [on, setOn] = useState(() => localStorage.getItem(KEY) === "1");
  useEffect(() => { applyA11y(on); }, [on]);

  const toggle = () => {
    const v = !on;
    setOn(v);
    localStorage.setItem(KEY, v ? "1" : "0");
  };

  return (
    <button type="button" data-testid="a11y-toggle" onClick={toggle} aria-pressed={on}
      title={on ? "Turn off big text & high contrast" : "Big text & high contrast"}
      className={`flex items-center gap-2 min-h-[48px] px-3 rounded-xl font-semibold transition-colors ${on ? "bg-slate-900 text-white" : "border-2 border-[#E2D9CE] hover:border-[#D96B43] text-slate-800"}`}>
      <Eye className="w-5 h-5" />
      <span className={compact ? "sr-only sm:not-sr-only" : ""}>{on ? "Big text: On" : "Big text"}</span>
    </button>
  );
}
